const htmlparser = require('htmlparser2');

String.prototype.capitalize = function(humanReadable = true) {
  return (humanReadable ? this.toLowerCase() : this).replace(
    /(?:^|\s)\S/g,
    function(a) {
      return a.toUpperCase();
    }
  );
};
String.prototype.stripHTML = function() {
  let strippedHtml = '';
  const parser = new htmlparser.Parser({
    ontext(text) {
      strippedHtml += text;
    },
  });
  parser.write(this);
  parser.end();

  return strippedHtml;
};
String.prototype.excerpt = function(limit = 200, trail = '...') {
  const str = this.stripHTML();
  return str.length > limit ? str.substring(0, limit) + trail : str;
};

Number.prototype.currency = function(precision) {
  let value = this;
  let data = `${this}`.split('.');
  if (data.length > 1) {
    if (data[1].replace(/0/g, '') === '') {
      return parseInt(data[0]);
    }
    if (precision === 0) {
      return Math.trunc(value);
    }
    if (precision) {
      return parseFloat(value.toFixed(precision));
    }
    return parseFloat(value);
  }
  return parseFloat(value);
};

Number.prototype.percent = function(percent, precision) {
  let value = this;
  if (!percent) {
    return 100;
  }
  return ((percent / 100) * value).currency(precision);
};

String.prototype.currency = function(precision) {
  let value = parseFloat(this);
  if (isNaN(value)) {
    return 0;
  }
  return value.currency(precision);
};

String.prototype.percent = function(percent, precision) {
  let value = parseFloat(this);
  if (isNaN(value)) {
    return 0;
  }
  return value.percent(percent, precision);
};

String.prototype.convertToReadable = function() {
  return this.replace(/(_|-)/g, ' ');
};

export default class Patch {
  static patchWindowObject(app) {
    window.$logout = async () => {
      if (await $question('Are you sure, you want to logout?')) {
        try {
          await app.$store.dispatch('auth/logout');
          $showSuccess('You are now logged out!', 'Bye!', 'auth-toast');
          await app.$router.push({ path: '/' });
        } catch (error) {
          if (error.response.status === 401) {
            $showSuccess('You are now logged out!', 'Bye!', 'auth-toast');
            await app.$router.push({ path: '/' });
            return;
          }
          $showError(error.message || 'Please try again!', 'Logout Failed!', {
            timeout: 6000,
            id: 'auth-toast',
          });
        }
      }
    };
    window.switchTheme = (theme) => {
      app.$vuetify.theme.isDark = theme === 'dark';
    };
    if (process.env.NODE_ENV === 'development') {
      window.app = app;
      window.$store = app.$store;
    }
    window.$theme = app.$vuetify.theme;
    window.$router = {
      push: (location) => {
        return app.$router.push(location);
      },
      back: () => {
        app.$router.back();
      },
    };
  }
}
